/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Stake_Switch_To_Native_TokenInputs */



/**
* | output |
* | --- |
* | "Switch Stake to Native Token" |
*
* @param {Metric_Stake_Switch_To_Native_TokenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_stake_switch_to_native_token = /** @type {((inputs?: Metric_Stake_Switch_To_Native_TokenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Stake_Switch_To_Native_TokenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Switch Stake to Native Token")
});